// getters and setters
function get__viewportW() {
    vw = $(window).width();
    return vw;
}
function get__navHeight() {
    hn = document.querySelector('.navbar').parentElement.clientHeight;
    return hn;
}
function get__page() {
    var fullUrl = window.location.href.split('/').reverse()[0];
    var testHash = fullUrl.split('#');
    if (testHash !== fullUrl) {
        fullUrl = testHash[0];
    }
    if ($.inArray(fullUrl, ['', undefined, null, 'home']) >= 0) {
        fullUrl = 'home';
    }
    return fullUrl;
}
function get__hash() {
    var hashOfThePage = window.location.hash;
    if ($.inArray(hashOfThePage, ['', undefined, null]) >= 0) {
        hashOfThePage = 'noHash';
    }
    return hashOfThePage;
}

function initGettersAndSetters() {
    get__viewportW();
    get__navHeight();
    get__page();
    get__hash();
    console.log('Page: ' + get__page() + ' | Hash: ' + get__hash());
}

// Identifica direcao do scroll
function scrollDirection() {
    var scrollInit = 0;
    $(window).on('scroll', function () {
        var scrollBody = $(this).scrollTop();
        if (scrollBody < scrollInit) {
            $('body').removeClass('hidden');
            $('body').addClass('scrolledUp');
            $('body').removeClass('scrolledDown');
        } else {
            $('body').removeClass('scrolledUp');
            $('body').addClass('scrolledDown');
        }
        scrollInit = scrollBody;
    });
}
// Example:
// $(window).on('load', function() {scrollDirection();});

// link scroll
function goToSection__scroll(elScrollDestiny, distanceIfScrollGoingToUp, distanceIfScrollGoingToDown, speedScroll, delay) {
    console.clear();
    // scroll reference
    var scrollEfetuado = $(window).scrollTop();
    console.log(scrollEfetuado);
    // element reference
    var sectionDestiny_offsetTop = $(elScrollDestiny).offset().top;
    console.log(elScrollDestiny);
    console.log(sectionDestiny_offsetTop);

    if (scrollEfetuado > sectionDestiny_offsetTop) {
        console.log('vai subir');
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: sectionDestiny_offsetTop - distanceIfScrollGoingToUp
            }, speedScroll);
        }, delay);
    } else {
        console.log('vai descer');
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: sectionDestiny_offsetTop - distanceIfScrollGoingToDown
            }, speedScroll);
        }, delay);
    }
}
// Example:
$('.js-linkScroll').on('click', function(e) {
    e.preventDefault();
    var finalDestiny = $(this).attr('href');
    goToSection__scroll(finalDestiny, 150, 150, 800, 0);
});

$(window).on('load', function () {
    scrollDirection();
    initGettersAndSetters();
});
$(window).on('hashchange', function () {
    initGettersAndSetters();
});

if ($('.auxElements__controls').length) {
    function identifyScroll() {
        returnScroll = 1;
        if ($('body').hasClass('scrolledDown')) {
            returnScroll = 'Down';
        } else if ($('body').hasClass('scrolledUp')) {
            returnScroll = 'Up';
        } else {
            returnScroll = 'Static';
        }
        return returnScroll;
    }
    function tasksAuxVars() {
        $('.auxElements__controls .scrollEfetuado').html(Math.round($(window).scrollTop()));
        $('.auxElements__controls .scrollDirection').html(identifyScroll());
        $('.auxElements__controls .viewportWidth').html(Math.round($(window).width()));
        $('.auxElements__controls .viewportHeight').html(Math.round($(window).height()));
        $('.auxElements__controls .navHeight').html(Math.round(get__navHeight()));
    }

    $(document).on('ready', function () {
        tasksAuxVars();
    });
    $(window).on('load', function () {
        tasksAuxVars();
    });
    $(window).on('resize', function () {
        tasksAuxVars();
    });
    $(window).on('scroll', function () {
        tasksAuxVars();
    });
}

function strip_tags(content){
    var txt = content.replace(/(<([^>]+)>)/gi, "");
    return txt.replace(/&nbsp;/gi, " ");
}

$(document).on("click", '.btnCopy', function(e){
    e.stopPropagation();
    e.preventDefault();
    var id = $(this).attr('data-id');
    copyToClipboard(id,true);
});

$(document).on("click", '.btnCopyText', function(e){
    e.stopPropagation();
    e.preventDefault();
    var id = $(this).attr('data-id'); 
    $(".editor").each(function () {
        let id = $(this).attr('id');
        editors[id].updateSourceElement();
    });
    copyToClipboard(id,false);
});

function copyToClipboard(element, is_html) {
    var $temp = $("<textarea>");
    $(element).parent().append($temp);
    if(is_html){
        $temp.val(strip_tags($(element).html().trim())).select();
    }else{
        $temp.val(strip_tags($(element).val().trim())).select();
    }
    document.execCommand("copy");
    $temp.remove();

    Toast.fire({
        icon:  'success',
        title: 'Texto copiado para a área de transferência!'
    });
} 
$('input, form').attr('autocomplete', 'off');

$(document).on('click', '.toggle-password', function () {
    var input = $("#input-password");
    if (input.attr("type") === "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    } 
});

$(document).on('change', '#select-grupos-users', function (e) {
    e.preventDefault();
    var target = '#loadUserType';
    var pk = $('option:selected', this).val();

    $(target).html('<label>Buscando tipos ...</label>');
    $.ajax({
        type: "POST",
        data: { grupo: pk },
        context: this,
        url: "tipos-users",
        success: function (result) {
            result = result.split('|');
            if(parseInt(result[1]) === 1){
                $(target).html(result[2]);
                $('.dinamicFieldsUsers').addClass('d-none').find('.checkHasRequired').removeAttr('required').prop('checked',false);
                if($('#'+pk).length){
                    $('#'+pk).removeClass('d-none').find('.checkHasRequired').attr('required','required'); 
                }
            }else{
                $(target).html(result[2]);
                $('#select-grupos-users').val('').select2({
                    placeholder: 'Selecione...'
                });
            }
        }
    });
});

$('body').on('change', '.checkTipo', function(){
    $('.checkTipo').each(function(){
        var pk = $(this).val();
        if($(this).prop("checked")){
            if($('#tipo-'+pk).length){
                $('#tipo-'+pk).removeClass('d-none').find('.checkHasRequired').attr('required','required'); 
            }
        }else{
            if($('#tipo-'+pk).length){
                $('#tipo-'+pk).addClass('d-none').find('.checkHasRequired').removeAttr('required').prop('checked',false);
            }
        }
    });
});

$('body').on('change', '#estado', function(){
    var uf = $(this).val();
    $("#cidade").html('<option>Carregando cidades...</option>');
    $.ajax({
        type: "POST",
        data: {uf: uf},
        url: "load-cidades",
        success: function (result) {
            $("#cidade").html(result);
        }
    });
});

$(document).on('change','.form-select-pais',function(){
    var pais = $(this).val();
    var target = $(this).attr('data-target');
    var targetCity = $(this).attr('data-city');
    var searchLoja = $(this).attr('data-loja'); 

    $(target).html('<option value="">Carregando cidades...</option>');
    $(targetCity).html('<option value="">Selecione</option>'); 
    $.ajax({
        type: "POST",
        data: {pais: pais},
        url: "select-estados",
        success: function (result) {
            $(target).html(result);
        }
    });

    if(searchLoja === 'S'){
        $.ajax({
            type: "POST",
            data: {pais: pais},
            url: "select-lojas",
            success: function (result) {
                $('#loja').html(result);
            }
        });
    }

});

$(document).on('change','.form-select-estado',function(){
    var uf = $(this).val();
    var returnCode = $(this).attr('data-return-code');
    var target = $(this).attr('data-target');
    $(target).html('<option value="">Carregando cidades...</option>');
    $.ajax({
        type: "POST",
        data: {uf: uf, code: returnCode},
        url: "select-cidades",
        success: function (result) {
            $(target).html(result);
        }
    });
});

/**
 * SELECT 2
 */
if ($('.js-select2').length) {
    $('.js-select2').select2({
        placeholder: 'Selecione...'
    });
}
if ($('#select-grupos-users').length) {
    $('#select-grupos-users').select2({
        placeholder: 'Selecione...'
    });
}

function select2Init(sourceField) {
    var targetData = sourceField.attr('data-id-target');
    console.log(targetData);
    var el = $('.js-select2-' + targetData);
    var refresh = el.attr('data-refresh-target');

    if (refresh === 'yes' && el.hasClass("select2-hidden-accessible")) el.select2('destroy');

    el.select2({
        ajax: {
            url: targetData + '/select2',
            dataType: 'json',
            method: 'post',
            context: this,
            data: function (params) {
                if (targetData === 'regioes') {
                    var query = {
                        search: params.term,
                        type: 'public',
                        estado: sourceField.val()
                    }
                } else if (targetData === 'cidades-regiao') {
                    var query = {
                        search: params.term,
                        type: 'public',
                        regiao: sourceField.val()
                    }
                }
                // Query parameters will be ?search=[term]&type=public
                return query;
            }
        },
        minimumInputLength: 3,
        placeholder: "Selecione",
        "language": {
            errorLoading: function () {
                return 'Os resultados não foram ser carregados.';
            },
            searching: function () { return 'Buscando…'; },
            "noResults": function () { return 'Nenhum item encontrado'; },
            inputTooShort: function (args) {
                var remainingChars = args.minimum - args.input.length;
                return 'Digite ' + remainingChars + ' ou mais caracteres';
            },
        }
    });
}

/**
 * Carrega as cidades de um estado
 */
$(document).on('change', '.load-cidades', function (e) {
    e.preventDefault();

    var target = '#' + $(this).attr('data-id-target');
    var pk = $('option:selected', this).val();

    $(target).html('<option>Carregando ...</option>');
    $.ajax({
        type: "POST",
        data: { estado: pk },
        context: this,
        url: "cidades/select",
        success: function (result) {
            $(target).html(result);
        }
    });
});

/**
* MASCARAS DE CAMPOS
*/
$(document).on("focus", ".maskHora", function () {
    $('.maskHora').mask('00:00');
});
$(document).on("focus", ".maskDataHora", function () {
    $('.maskDataHora').mask('00/00/0000 00:00');
});
$(document).on("focus", ".maskData", function () {
    $('.maskData').mask('00/00/0000', { reverse: true });
});
$(document).on("focus", ".maskCEP", function () {
    $('.maskCEP').mask('00000-000', { reverse: true });
});
$(document).on("focus", ".maskValor", function () {
    var mask = '000.000,00';
    var maxlength = $(this).attr('maxlength');
    if (maxlength != '') {
        mask = mask.substr(maxlength * -1);
    }
    $('.maskValor').mask(mask, { reverse: true });
});
$(document).on("focus", ".maskDecimal", function () {
    var mask = '0000,00';
    var maxlength = $(this).attr('maxlength');
    if (maxlength != '') {
        mask = mask.substr(maxlength * -1);
    }
    $('.maskDecimal').mask(mask, { reverse: true });
});
$(document).on("focus", ".maskNumber", function () {
    var mask = '0000';
    var maxlength = $(this).attr('maxlength');
    if (maxlength != '') {
        mask = mask.substr(maxlength * -1);
    }
    $('.maskNumber').mask(mask, { reverse: true });
});
$(document).on("focus", ".maskCPF", function () {
    $('.maskCPF').mask('000.000.000-00', { reverse: true });
});
$(document).on("focus", ".maskCNPJ", function () {
    $('.maskCNPJ').mask('00.000.000/0000-00', { reverse: true });
});
$(document).on("focus", ".maskTelefone", function () {
    var TelefoneMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(99) 00000-0000' : '(99) 0000-00009';
    },
        spOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(TelefoneMaskBehavior.apply({}, arguments), options);
            }
        };
    $('.maskTelefone').mask(TelefoneMaskBehavior, spOptions);
});

function somenteNumeros(e) {
    var charCode = e.charCode ? e.charCode : e.keyCode;
    // charCode 8 = backspace
    // charCode 9 = tab
    if (charCode != 8 && charCode != 9) {
        // charCode 48 equivale a 0
        // charCode 57 equivale a 9
        if (charCode < 48 || charCode > 57) {
            return false;
        }
    }
}

/**
* ATIVO INATIVO NAS LISTAS DE REGISTROS
* Uso:
* <label class="form-check form-switch mb-0 d-inline-block">
*     <input class="form-check-input form-ativo" name="ativo" value="S" data-tipo="segmento" data-codigo="<?php echo md5($row['codigo']); ?>" type="checkbox" <?php echo ($row['ativo']=='S') ? 'checked' : ''; ?> >
* </label>
*/
$('.form-ativo').change(function () {
    var tipo = $(this).attr('data-tipo') + "/situacao";
    var codigo = $(this).attr('data-codigo');
    var novo_valor = '';
    if (this.checked) {
        novo_valor = 'S';
        $(this).prop("checked", true);
    } else {
        $(this).prop("checked", false);
        novo_valor = '';
    }

    $.ajax({
        type: "POST",
        url: tipo,
        context: this,
        data: { codigo: codigo, valor: novo_valor, acao: tipo },
        success: function (result) {
            //$('.row-images-cards').html(result);
        }
    });
})

/**
 * ALERTA RAPIDO TOP RIGHT
 */
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

function toastFire(response, Toast) {
    response = response.split('|');
    Toast.fire({
        icon: (parseInt(response[1]) === 1) ? 'success' : 'error',
        title: response[2]
    });
    return true;
}


$('body').on('change', '.markOption',function () {
    var name = $(this).attr('data-name');
    var codigo = $(this).attr('data-codigo');
    var novo_valor = '';
    if (this.checked) {
        novo_valor = 'S';
        $(this).prop("checked", true);
    } else {
        $(this).prop("checked", false);
        novo_valor = 'N';
    }

    $.ajax({
        type: "POST",
        url: 'envia-xeditable',
        context: this,
        data: { name: name, value: novo_valor, pk: codigo },
        success: function (result) {
            toastFire(result, Toast);
        }
    });
})

/**
 * X-EDITABLE
 */
function startXEditable() {
    if ($('.textDisable').length) {
        $('.textDisable').editable({
            showbuttons: false,
            placement: 'left',
            inputclass: 'input-disabled',
            tpl: '<textarea readonly></textarea>'
        });
    }

    if ($('.upd-text').length) {
        $('.upd-text').editable({
            tpl: '<input type="text" class="form-control">',
            emptytext: 'Editar',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-textarea').length) {
        $('.upd-textarea').editable({
            emptytext: 'Editar',
            inputclass: 'form-control',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-decimal').length) {
        $('.upd-decimal').editable({
            tpl: '<input type="text" class="form-control">',
            emptytext: 'Editar',
            inputclass: 'maskDecimal',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-data').length) {
        $('.upd-data').editable({
            emptytext: 'Editar',
            mode: 'popup',
            inputclass: 'form-select',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-date').length) {
        $('.upd-date').editable({
            tpl: '<input type="text" class="form-control">',
            emptytext: 'Editar',
            inputclass: 'form-control maskData datePicker',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-datetime').length) {
        $('.upd-datetime').editable({
            tpl: '<input type="text" class="form-control">',
            emptytext: 'Editar',
            inputclass: 'form-control maskDataHora datetimePicker',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });
    }

    if ($('.upd-select').length) {
        $('.upd-select').editable({
            emptytext: 'Editar',
            mode: 'popup',
            inputclass: 'form-select',
            success: function (response, newValue) {
                toastFire(response, Toast);
            }
        });

        $('.upd-select').on('save', function (e, params) {
            console.log('Saved value: ' + params.newValue);
        });
    }

    if ($('.upd-ativo').length) {
        $('.upd-ativo').editable({
            mode: 'popup',
            success: function (response, newValue) {
                if (newValue === 'N') {
                    $(this).removeClass('label-success').addClass('label-danger');
                } else {
                    $(this).removeClass('label-danger').addClass('label-success');
                }
                toastFire(response, Toast);
            }
        });
    }

    $('.updSimNao').editable({
        mode: 'popup',
        inputclass: 'form-select',
        source: [
            {value: 'N', text: 'Não'},
            {value: 'S', text: 'Sim'}
        ],
        success: function (response, newValue) {
            toastFire(response, Toast);
        }
    });
}
startXEditable();

/**
 * DRAG & DROP DOS ARQUIVOS
 */
var fileActionSettingsArray = {
    removeIcon: '<i class="ti ti-trash"></i>',
    uploadIcon: '<i class="ti ti-cloud-upload"></i>',
    uploadRetryIcon: '<i class="ti ti-rotate-clockwise"></i>',
    downloadIcon: '<i class="ti ti-download"></i>',
    zoomIcon: '<i class="ti ti-zoom-in"></i>',
    dragIcon: '<i class="ti ti-arrows-move"></i>',
    indicatorNew: '<i class="ti ti-plus-lg text-warning"></i>',
    indicatorSuccess: '<i class="ti ti-check-lg text-success"></i>',
    indicatorError: '<i class="ti ti-exclamation-lg text-danger"></i>',
    indicatorLoading: '<i class="ti ti-hourglass-bottom text-muted"></i>',
    indicatorPaused: '<i class="ti ti-pause-fill text-primary"></i>',
};
var previewZoomButtonIconsArray = {
    prev: '<i class="ti ti-chevron-left"></i>',
    next: '<i class="ti ti-chevron-right"></i>',
    toggleheader: '<i class="ti ti-maximize"></i>',
    fullscreen: '<i class="ti ti-arrows-maximize"></i>',
    borderless: '<i class="ti ti-layout-navbar"></i>',
    close: '<i class="ti ti-x"></i>'
}
function uploadFiles() {
    $("#uploadFiles").fileinput({
        language: 'pt-BR',
        uploadUrl: "upload",
        uploadAsync: false,
        maxFileCount: 20,
        showClose: false,
        fileActionSettings: fileActionSettingsArray,
        previewZoomButtonIcons: previewZoomButtonIconsArray,
        allowedFileExtensions: ['jpg', 'png', 'jpeg', 'gif', 'bmp', 'svg', 'mp3', 'aac', 'ogg', 'wma', 'wav', 'mp4', 'mov', 'wmv', '3gp', 'rm', 'avi'],
        maxFileSize: 204800,
        uploadExtraData: function () {
            return {
                avaliacao: $("#avaliacao").val()
            };
        }
    }).on('filebatchuploadcomplete', function (event, files, extra) {
        if ($('#formChecklist').length) {
            $('#formChecklist').submit();
        } else {
            $('#modalArquivos').modal('toggle');
        }
    });
}

/**
 * MODAL
 */
$(document).on('click', '.btn-modal', function (e) {
    e.preventDefault();
    var modal = $(this).attr('href');
    var codigo = $(this).attr('data-codigo');
    $.post(modal,
        { codigo: codigo },
        function (resultado) {
            $('body').append(resultado);
            $('#modal').modal('show');

            $('#modal').on('shown.bs.modal', function (e) {
                startXEditable();
                if ($('#uploadFiles').length) uploadFiles();
            });

            $('#modal').on('hidden.bs.modal', function (e) {
                $('#modal').remove();
            });
        });
});

// Pega o maior valor de z-index no DOM
function getMaxZIndex() {
    return Math.max(
        ...Array.from(document.querySelectorAll('body *'), el =>
            parseFloat(window.getComputedStyle(el).zIndex),
        ).filter(zIndex => !Number.isNaN(zIndex)),
        0,
    );
}

/**
 * OFFCANVAS
 */
$(document).on('click', '.btn-offcanvas', function (e) {
    e.preventDefault();
    $('#offcanvas').offcanvas('hide');
    var offcanvas = $(this).attr('href');
    var codigo = $(this).attr('data-codigo');
    $.post(offcanvas,
        { codigo: codigo },
        function (resultado) {
            $('body').append(resultado);

            $('#offcanvas').offcanvas('show');
            $('.offcanvas-backdrop').css('z-index', getMaxZIndex() + 1);
            $('#offcanvas').css('z-index', getMaxZIndex() + 2);

            $('#offcanvas').on('shown.bs.offcanvas', function (e) {
                startXEditable();
                $('[data-bs-toggle="tooltip"]').tooltip();
            });

            $('#offcanvas').on('hidden.bs.offcanvas', function (e) {
                $('#offcanvas').remove();
            });
        });
});

$(document).on('click', '#formDefault .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();

    //form.find('.ck-editor input').addClass('novalidate'); //nao validar campos dentro do ckEditor
    $('.ck-editor').find('input').addClass('novalidate'); //nao validar campos dentro do ckEditor

    $(".editor").each(function () {
        let id = $(this).attr('id');
        editors[id].updateSourceElement();
    });

    $(".editorFull").each(function () {
        let id = $(this).attr('id');
        editors[id].updateSourceElement(); 
    });

    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Enviando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if (parseInt(result[1]) === 1) {
                    Swal.fire({
                        title: result[2],
                        html: result[3], 
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        var redirect = btn.attr('data-redirect');
                        if (redirect){
                            if(redirect === 'close-modal'){
                                $('#modalPosts').modal('hide');
                                location.reload(); 
                            }else{
                                location.href = redirect; 
                            }                            
                        }else{
                            location.reload(); 
                        }                            
                    });
                } else {
                    Swal.fire({
                        text: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false 
                    }).then(function (res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('change', '.radioAprovText', function() {
    var val = $(this).val();
    var target = $(this).attr('data-target');
    if(val !== '' && val !== null && val!== undefined){
        if(val === 'S'){
            $('.'+target).hide();
            $('.'+target).children('textarea').removeAttr('required').val('');
        }else{
            $('.'+target).show();
            $('.'+target).children('textarea').attr('required','required');
        }
    }
});

$(document).on('change', '.checkAprovText', function() {
    var target = $(this).attr('data-target');
    if($(this).prop('checked')){
        $('.'+target).show();
        $('.'+target).children('textarea').attr('required','required');
        $('.'+target).find('select').attr('required','required');
    }else{
        $('.'+target).hide();
        $('.'+target).children('textarea').removeAttr('required').val('');
        $('.'+target).find('select').removeAttr('required').val('');
    }
});

/* PAGE-PRODUTO.PHP */
/* ZOOM IMAGEM */
function easyZoom() {
    // Instantiate EasyZoom instances
    var $easyzoom = $('.easyzoom').easyZoom();
    // Get an instance API
    var api = $easyzoom.data('easyZoom');
}

if ($('.easyzoom').length) {
    easyZoom();
}

$(document).on('click', '.btn-galeria', function (e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo'); // codigo do produto
    var cor = $(this).attr('data-cor'); // codigo da cor
    $.post('produto/galeria',
        { codigo: codigo, cor: cor, ajax: true },
        function (resultado) {
            $('#galeria-produto').html(resultado);
            $('[data-bs-toggle="tooltip"]').tooltip();
            //$('.btn-galeria [data-bs-toggle="tooltip"]').enable();
            easyZoom();
        });
});

$(document).on('click', '.removeImgClone', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-id');
    
    Swal.fire({
        title: 'Deseja remover realmente?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonText: 'Sim, excluir!',
        confirmButtonColor: '#2fb344'
    }).then((result) => {
        if (result.value) {
            $('#'+codigo).remove();
            if($('.contentImgClone').length < 1 && $('.imgAprovadaInAjuste').length < 1){
                $('input.galeria').attr('required','required');
                var categoria = $('[name="categoria_id"]:checked').val();
                var isRequiredSociais = $('.loadSociaisArtes.isRequiredSociais').length;
                if(parseInt(categoria) === 3 || isRequiredSociais > 0){ 
                    $('.checkbox-sociais-img input').attr('required','required');
                }
            }
            Toast.fire({
                icon: 'success',
                title: 'Arquivo removido!'
            });
        }
    })
})

$(document).on('click', '.btnExcluirSolicitacao', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações relacionadas desta solicitação!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#2fb344',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo, acao: 'solicitacao-remover'},
                url: "envia-solicitacao",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) === 1) {
                        $('#solicitacao-' + codigo).remove();
                        Swal.fire({
                            title: result[2],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('click', '.btnRestauraSolicitacao', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    var processo = $(this).attr('data-processo');
    Swal.fire({
        title: 'Deseja restaurar esta solicitação?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#2fb344',
        confirmButtonText: 'Sim, restaurar!'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo, processo: processo, acao: 'solicitacao-restaurar'},
                url: "envia-solicitacao",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) === 1) {
                        Swal.fire({
                            title: result[2],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            location.reload();                        
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('change', '.checkAprovArte', function() {
    var val = $(this).val();
    var target = $(this).attr('data-target');
    if(val !== '' && val !== null && val!== undefined){
        if(val === 'S'){
            $('.'+target).hide().find('textarea').removeAttr('required').val('');
        }else{
            $('.'+target).show().find('textarea').attr('required','required');
        }
    }
});

$(document).on('change', '.checkSolicitaMais', function() {
    var val = $(this).val();
    if($(this).prop("checked")){
        $('.field_obs_SolicitaMais').show().find('textarea').attr('required','required');
    }else{
        $('.field_obs_SolicitaMais').hide().find('textarea').removeAttr('required').val('');
    }
});

$(document).on('change', '.checkAprovTexto', function() {
    var val = $(this).val();
    var target = $(this).attr('data-target');
    if(val !== '' && val !== null && val!== undefined){
        if(val === 'S'){
            $('.'+target).hide().find('textarea').removeAttr('required').val('');
        }else{
            $('.'+target).show().find('textarea').attr('required','required');
        }
    }
});

$(document).on('click', '.btnOpenPost', function(e) {
    e.preventDefault();
    var post = $(this).attr('data-post');
    var rede = $(this).attr('data-rede');
    var cliente = $(this).attr('data-cliente');
    var titulo = $(this).attr('data-titulo');
    var uri = $('body').attr('data-app-url');
    $.post(uri + "/load-modal-redes", { post: post, rede: rede, titulo: titulo, cliente:cliente }, function(resultado){
        $('body').append(resultado);

        $('.slickPost').slick({
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            adaptiveHeight: true,
            touchMove: false,
            draggable: false
        });

        $('#modalPost').modal('show');

        $('#modalPost').on('shown.bs.modal', function (e) {
            $('.slickPost').slick('setPosition');
        })

        $('#modalPost').on('hidden.bs.modal', function (e) {
            $('#modalPost').remove();
        });
    });
});

$(document).on('click', '.btn-downPosts', function(e) {
    e.preventDefault();
    var post = $(this).attr('data-href');
    var regras = $('#regrasUso').html();
    Swal.fire({
        title: 'Regras de Uso',
        html: regras,
        icon: 'info',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#2fb344',
        confirmButtonText: 'Sim, estou de acordo!'
    }).then((result) => {
        if (result.value) {
            location.href=post;
        }
    });
});

$(document).on('click', '.btnOpenModalArtesFinalizadas', function(e) {
    e.preventDefault(); 
    var codigo = $(this).attr('data-codigo');
    var titulo = $(this).attr('data-titulo');
    var uri = $('body').attr('data-app-url');
    console.log(uri);
    $.post(uri + "/load-modal-finalizados", { codigo: codigo,titulo:titulo}, function(resultado){
        $('body').append(resultado);
        $('#modalPosts').modal('show');
        $('#modalPosts').on('hidden.bs.modal', function (e) {
            $('#modalPosts').remove();
        });
    });
});

$(document).on('click', '.btnOpenModalSugeridas', function(e) {
    e.preventDefault(); 
    var codigo = $(this).attr('data-codigo');
    var titulo = $(this).attr('data-titulo');
    var uri = $('body').attr('data-app-url');
    $.post(uri + "/load-modal-sugeridas", { post: codigo,titulo:titulo}, function(resultado){
        $('body').append(resultado);
        $('#modalSugeridas').modal('show');
        $('#modalSugeridas').on('hidden.bs.modal', function (e) {
            $('#modalSugeridas').remove();
        });
    });
});

$(document).on('click', '.btnOpenModalInserirTexto', function(e) {
    e.preventDefault(); 
    var codigo = $(this).attr('data-codigo');
    var uri = $('body').attr('data-app-url');
    console.log(uri);
    $.post(uri + "/insere-legendas", { codigo: codigo}, function(resultado){
        $('body').append(resultado);
        $('#modalPosts').modal('show');
        $('#modalPosts').on('hidden.bs.modal', function (e) {
            $('#modalPosts').remove();
        });
    });
});

$(document).on('click', '.btnOpenModalTraducao', function(e) {
    e.preventDefault(); 
    var codigo = $(this).attr('data-codigo');
    var idiomas = $(this).attr('data-idiomas');
    var uri = $('body').attr('data-app-url');
    console.log(uri);
    $.post(uri + "/solicita-traducao", { codigo: codigo,idiomas: idiomas}, function(resultado){
        $('body').append(resultado);
        $('#modalTraducao').modal('show');
        $('#modalTraducao').on('hidden.bs.modal', function (e) {
            $('#modalTraducao').remove();
        });
    });
});

$(document).on('click', '.btnOpenModalListAgenda', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    $.ajax({
        url: 'agendamentos/evento/modal/loadModal.php',
        type: "POST",
        data: {codigo: codigo, edit: 'N', list: 'S'},
        success: function (result) {
            $('#ModalAgenda .modal-content .card-body').html(result);
            $('#ModalAgenda').modal('show');
        }
    });
});

$(document).on('click', '.btnOpenModalTimeline', function(e) { 
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    var uri = $('body').attr('data-app-url');
    $.ajax({
        url: uri + '/load-timeline',
        type: "POST",
        data: {codigo: codigo},
        success: function (result) {
            $('body').append(result);
            $('#modalHistorico').modal('show');
            $('#modalHistorico').on('hidden.bs.modal', function (e) {
                $('#modalHistorico').remove();
            });
        }
    });
});

if($('#texto-imagem').length){
    var textareaImagem = document.getElementById('texto-imagem');
    textareaImagem.addEventListener('input', function (event) {

        var vText = $('[name="set-texto"]:checked').val();
        if(event.target.value !== '' && event.target.value !== undefined && event.target.value !== null){
            $('.revisorContent').removeClass('d-none').find('.isRequired').attr('required','required');
        }else{
            if(vText === 'N'){
                $('.revisorContent').addClass('d-none').find('.isRequired').removeAttr('required'); 
            }
        }

        console.log(vText);
    });
} 

$(document).ready(function() {
    /** MANTEM A CONEXAO ATIVA */
    window.setInterval(function () {
        $.ajax({
            type: "POST",
            url: "incs/keep-loged-in.php",
            success: function(result){
                console.log(result);
            }
        });
    }, 60000 * 2); // 60 segundos * 2 Minutos
});
$(document).on('change', '.checkSetCategoria input', function(e) {
    e.preventDefault();
    var categoria = $('[name="categoria_id"]:checked').val();
    $.ajax({
        type: "POST",
        data: {categoria: categoria},
        url: "load-tiposField",
        success: function (result) {
            result = result.split('|');
            if(parseInt(result[1]) === 1){
                $('.cat').addClass('d-none').find('.isRequired').removeAttr('required');
                $('.rede').addClass('d-none').find('.isRequired').removeAttr('required');
                $('.cat-'+categoria).removeClass('d-none').find('.isRequired').attr('required','required');
                $('.rede-'+categoria).removeClass('d-none').find('.isRequired').attr('required','required');
                $('.desenvTexto,.desenvArte').removeClass('d-none');
            }
            $('.tipoMaterial').removeClass('d-none');
            $('.tipoMaterial .row').html(result[2]);
            if(parseInt(categoria) === 3) {
                removeFieldsTraducao();
            }else{
                $('.traduzirTexto').removeClass('d-none');
            }
            console.log(categoria);
        }
    });
    showConteudoFields();
});

$(document).on('change', '[name="set-texto"]', function(e) {
    e.preventDefault();
    showConteudoFields();
});

$(document).on('change', '[name="set-traducao"]', function(e) {
    e.preventDefault();
    showConteudoFields();
});

$(document).on('change', '[name="set-arte"]', function(e) {
    e.preventDefault();
    showConteudoFields();
});

$(document).on('change', '.setIdiomas', function() {
    liberaConteudoIdiomas();
});

$(document).on('change', '.checkSociais', function() {
    atualizaRedesSociais();
});

$(document).on('change', '[name="direitos_autorais"]', function(e) {
    e.preventDefault();
    setDireitosAutorais();
});

/*$(document).on('change', '#conteudo', function(e) {
    console.log('asdfg1234');
});*/

$(document).on('change', '.fieldPublico', function(e) {
    e.preventDefault();
    $('.public').addClass('d-none').find('.isRequired').removeAttr('required');
    $('.fieldPublico').each(function(){
        if($(this).prop('checked')){
            var val = $(this).val();
            $('.public-'+val).removeClass('d-none').find('.isRequired').attr('required','required');
        }
    });
    atualizaRedesSociais();
});

$(document).on('click', '#formSolicitacao .btn-clone', function(e) {
    e.preventDefault();
    cloneRow();
    controlaBtnClone();
});

$(document).on('click', '#formSolicitacao .btn-link-add', function(e) {
    e.preventDefault();
    cloneLink();
    controlaBtnCloneLink();
});

$(document).on('click', '#formSolicitacao .btn-data-add', function(e) {
    e.preventDefault();
    cloneData();
});

$(document).on('click', '#formSolicitacao .btn-remover', function(e) {
    e.preventDefault();
    var row = $(this).closest('.row-gallery');
    var input = row.find('input[type="file"]');

    //if (($( "#formSolicitacao .row-gallery").length > 1)&&(row.attr('id') !== 'clone'))
        //row.remove();

    if (row.attr('id') !== 'clone')
        row.remove();    

    if (row.attr('id')==='clone') {
        input.replaceWith(input.val('').clone(true));
        row.find('input[type="text"]').val('');
    }
    controlaBtnClone();
});

$(document).on('click', '#formSolicitacao .btn-remover-link', function(e) {
    e.preventDefault();
    var row = $(this).closest('.row-link');
    var input = row.find('input[type="text"]');

    if (($( "#formSolicitacao .row-link").length > 1)&&(row.attr('id') !== 'clone-link'))
        row.remove();

    if (row.attr('id')==='clone-link') {
        row.find('input[type="text"]').val('');
    }
    controlaBtnCloneLink();
});

$(document).on('click', '#formSolicitacao .btn-remover-data', function(e) {
    e.preventDefault();
    var row = $(this).closest('.row-data');
    var input = row.find('input[type="text"]');

    if (($( "#formSolicitacao .row-data").length > 1)&&(row.attr('id') !== 'clone-data'))
        row.remove();

    if (row.attr('id')==='clone-data') {
        row.find('input[type="text"]').val('');
    }
});

$(document).on('click', '#formSolicitacao .btnSaveSolicitacao', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');

    //form.find('.ck-editor input').addClass('novalidate'); //nao validar campos dentro do ckEditor
    $('.ck-editor').find('input').addClass('novalidate'); //nao validar campos dentro do ckEditor

    $(".editor").each(function () {
        let id = $(this).attr('id');
        editors[id].updateSourceElement();
    });

    $(".editorFull").each(function () {
        let id = $(this).attr('id');
        editors[id].updateSourceElement(); 
    });  

    $('.formLegendas .card-title').removeClass('c-color-error');
    $('.nav-item.grupo-legenda').children('.nav-link').removeClass('hasFieldError');

    if (form.smkValidate()) {
        //form.submit();
        //SUBMIT form
        form.ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-1" role="status"></span> Enviando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[1]) === 1){
                    Swal.fire({
                        title: result[2],
                        text: result[3],
                        icon: 'success',
                        timer: 5000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.href = result[4];
                    });
                }else{
                    Swal.fire({
                        title: 'Erro:',
                        text: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html('Salvar').attr('disabled', false);
                    });
                }
            }
        });
    }else{
        $('.tab-pane.grupo-legenda .has-error').each(function(){
            var arrGrupo = $(this).parents('.grupo-legenda').attr('id').split('-');
            $('.nav-item.grupo-social-'+arrGrupo[1]).children('a').addClass('hasFieldError');
            $('.formLegendas .card-title').addClass('c-color-error');
        });
    }
});

$(document).on('change', '.tipoTexto', function() {
    var val = $(this).val();
    if(val !== '' && val !== null && val!== undefined){
        if(val === 'file_brContent'){
            $('#file_brContent').removeClass('d-none').children('input').attr('required','required');
            $('#text_brContent').addClass('d-none').children('textarea').removeAttr('required');
        }else{
            $('#file_brContent').addClass('d-none').children('input').removeAttr('required').val('');
            $('#text_brContent').removeClass('d-none').children('textarea').attr('required','required')
        }
    }
});

document.addEventListener("DOMContentLoaded", function() {

        $('#tempFileInput').on('change', function() {
            //imagesPreview(this, 'div.gallery');
            Swal.fire({
                title: 'Carregando arquivos...',
                text: 'Aguarde finalizar',
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            })
            obj = this;
            $.each(obj.files,function(j, file){

                const dt = new DataTransfer();
                dt.items.add(file);
                var input=document.createElement('input');
                input.type="file";
                input.name="imgs[]";
                input.className="d-none";
                input.files = dt.files;

                var preview;

                var reader = new FileReader();
                reader.onload = function(event) {
                    preview = event.target.result;
                    var clone = $("#formSolicitacao #clone").clone().removeAttr('id').removeClass('d-none').addClass('row-gallery');
                    if(preview.substr(0, 10) === 'data:video'){
                        clone.find('.imgPreview').attr('src','dist/img/video.png');
                    }else{
                        clone.find('.imgPreview').attr('src',preview);
                    }
                    //clone.find('.galeria').attr('name','imgs[]');
                    //clone.find('.galeria').files = file;
                    clone.find('.InputFileContent').append(input);
                    clone.find('.legenda-imgtxt').val('');
                    clone.find('[type="checkbox"]').prop('checked',false);

                    clone.find('.checkbox-sociais-img').children('[type="checkbox"]').attr('name', 'rede_social_img_' + j + '[]');
                    clone.find('.legenda-imgtxt').attr('name', 'legenda_' + j);

                    clone.appendTo('div.gallery');


                    Swal.close();

                    var i = 0;
                    $( "#formSolicitacao .row-gallery").each(function(){
                        $(this).find('.checkbox-sociais-img').children('[type="checkbox"]').attr('name', 'rede_social_img_' + i + '[]');
                        $(this).find('.legenda-imgtxt').attr('name', 'legenda_' + i);
                        i++;
                    });
                }
                reader.readAsDataURL(dt.files[0]);                
                
            })
            //$('#tempFileInput').val('').removeAttr('required');
            atualizaRedesSociais();
        });

    });
$(document).on('click', '.btnExcluirCliente', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    var item_id = $(this).attr('data-item');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações relacionadas deste cliente!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonText: 'Sim, excluir!',
        confirmButtonColor: '#2fb344'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo,item_id: item_id, acao: 'cliente-remover'},
                url: "cliente-remover",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) === 1) {
                        $('#user' + codigo).remove();
                        Swal.fire({
                            title: result[2],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('click', '.btnEnviaCadSenha', function (e) {
    e.preventDefault();

    var btn = $(this);
    var btnTextoOriginal = btn.html();
    var emailField = $(this).attr('data-email');

    btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Enviando ...').attr('disabled', true);
    $.ajax({
        type: "POST",
        data: { email_lost_pass: emailField, from_panel:'S' },
        context: this,
        url: "envia-mail-senha",
        success: function (result) {
            result = result.split('|');
            console.log(result);
            Swal.fire({
                html: result[2],
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#2fb344',
                allowOutsideClick: false
            })
            btn.html(btnTextoOriginal).attr('disabled', false);
        }
    });
});

$(document).on('click', '#formPosts .btnSaveTextForn', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');

    $(".editor").each(function () {
        let id = $(this).attr('id');
        editors[id].updateSourceElement();
    }); 

    if (form.smkValidate()) {
        //form.submit();
        //SUBMIT form
        form.ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm me-1" role="status"></span> Enviando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if(parseInt(result[1]) === 1){
                    Swal.fire({
                        title: result[2],
                        text: result[3],
                        icon: 'success',
                        timer: 5000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.href = result[4];
                    });
                }else{
                    Swal.fire({
                        title: 'Erro:',
                        text: result[2], 
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html('Salvar').attr('disabled', false);
                    });
                }
            }
        });
    }
});
function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

function validaCPF(CPF) {
    var erro = 0;
    var Soma;
    var Resto;
    var strCPF = CPF.replace(".", ""); //tira ponto
    strCPF = strCPF.replace(".", ""); //tira o segundo ponto
    strCPF = strCPF.replace("-", ""); //tira hífen
    Soma = 0;
    if (strCPF == "00000000000") erro = 1;
    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) erro = 1;
    Soma = 0;
    for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) erro = 1;
    if (erro == 0) {
        return true;
    } else {
        return false;
    }
}

function validaCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj == '') return false;
    if (cnpj.length != 14)
        return false;
    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;
    // Valida DVs
    tamanho = cnpj.length - 2
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
        return false;
    return true;
}

function somenteNumeros(e) {
    var charCode = e.charCode ? e.charCode : e.keyCode;
    // charCode 8 = backspace
    // charCode 9 = tab
    if (charCode != 8 && charCode != 9) {
        // charCode 48 equivale a 0
        // charCode 57 equivale a 9
        if (charCode < 48 || charCode > 57) {
            return false;
        }
    }
}

function copyToClipBoard(fieldId) {
    // Get text
    var txt = $('#'+fieldId).text();
    // Create new element
    console.log(txt);
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = txt;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style = {
        position: 'absolute',
        left: '-9999px'
    };
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
    toastFire('1|Texto copiado para a área de transferência', Toast)
    return false;
}

function confirmaExcluir(pUrl, pCodigo, pRowPrefix) {
    var row = (pRowPrefix) ? pRowPrefix : 'row';
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações relacionadas a este registro!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonColor: '#206bc4',
        confirmButtonText: 'Sim, excluir!'
    }).then((result) => {
        if (result.isConfirmed) {
            $.ajax({
                type: "POST",
                data: {codigo: pCodigo}, //pCodido em enc()
                url: pUrl,
                success: function (response) {
                    result = response.split('|');
                    console.log(pCodigo, response, result);
                    if (parseInt(result[0]) === 1) {
                        $('#' + row + pCodigo).remove();
                        toastFire(response, Toast);
                    } else {
                        Swal.fire({
                            text: result[1],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
}

function checkSizesFiles(classe){
    var totalSize = 0;
    var maxSize = $('#max-size-upload').attr('data-max-size');
    $('form '+classe).each(function() {
        var input = $(this);
        var value = input.val();
        var type = input.attr('type');
        if (value !== "") {
            if (type === 'file') {
                totalSize = (totalSize + input[0].files[0].size);
            }
        }
    });
    return parseInt(maxSize) > totalSize;
}

function controlaBtnClone() {
    if ($( "#formSolicitacao .row-gallery").length < 20) {
        $('.btn-clone-galery').removeAttr('disabled');
    } else {
        $('.btn-clone-galery').attr('disabled', 'disabled');
    }
}

function cloneRow() {
    var clone = $("#formSolicitacao #clone").clone().removeAttr('id');
    clone.find('.galeria').val('');
    clone.find('.legenda-imgtxt').val('');
    clone.find('[type="checkbox"]').prop('checked',false);
    if ($( "#formSolicitacao .row-gallery").length < 20){
        $( "#formSolicitacao .row-add-files" ).append( clone );
        var i = 0;
        $( "#formSolicitacao .row-gallery").each(function(){
            $(this).find('.checkbox-sociais-img').children('[type="checkbox"]').attr('name', 'rede_social_img_' + i + '[]');
            $(this).find('.legenda-imgtxt').attr('name', 'legenda_' + i);
            i++;
        });
    }
}

function controlaBtnCloneLink() {
    if ($( "#formSolicitacao .row-link").length < 20) {
        $('.btn-clone-links').removeAttr('disabled');
    } else {
        $('.btn-clone-links').attr('disabled', 'disabled');
    }
}

function cloneLink() {
    var clone = $("#formSolicitacao #clone-link").clone().removeAttr('id');
    clone.find('[type="text"]').val('');
    clone.find('[type="checkbox"]').prop('checked',false);
    if ($( "#formSolicitacao .row-link").length < 20){
        $( "#formSolicitacao .row-add-links" ).append( clone );
    }
} 

function cloneData() {
    var clone = $("#formSolicitacao #clone-data").clone().removeAttr('id');
    clone.find('[type="text"]').val('');
    if ($( "#formSolicitacao .row-data").length < 20){
        $( "#formSolicitacao .row-add-datas" ).append( clone );
    }
} 

function atualizaRedesSociais() {
    var categoria = $('[name="categoria_id"]:checked').val();
    var setText = $('[name="set-texto"]:checked').val();
    var setArte = $('[name="set-arte"]:checked').val();
    var editLocal = $('[name="acao"]').val();
    console.log(editLocal);
    if(parseInt(categoria) === 3){
        if(setArte === 'N'){
            $('.loadSociaisArtes').addClass('d-none').find('.form-check-input').removeAttr('required');
        }else{
            if($('.contentImgClone').length < 1) {
                //if($('#tempFileInput').length < 1){
                    $('.row-gallery .loadSociaisArtes').removeClass('d-none').find('.form-check-input').attr('required','required');
                //}              
            }else{
                $('.loadSociaisArtes').removeClass('d-none');
            }
        }

        $('.nav-item.grupo-legenda').addClass('d-none');
        $('.tab-pane.grupo-legenda').addClass('d-none');

        $('.checkSociais').each(function(){
            var grupo = $(this).attr('data-grupo');
            var cod_rede = $(this).val();

            console.log('g='+grupo+' || t='+setText); 
            if($(this).prop('checked')){
                if(setText === 'I' || editLocal === 'editarCoordSolicitacao' || editLocal === 'ajustarTextoSolicitacao'){
                    $('.nav-item.grupo-social-' + grupo).removeClass('d-none');
                    $('.tab-pane.grupo-social-' + grupo).removeClass('d-none');
                }
                $('[data-rede="social-img-' + cod_rede + '"]').removeClass('d-none');
            }else{
                $('[data-rede="social-img-' + cod_rede + '"]').addClass('d-none').children().prop('checked',false);
            }
        })
        if(setText === 'I' || editLocal === 'editarCoordSolicitacao' || editLocal === 'ajustarTextoSolicitacao'){
            $('.formLegendas').removeClass('d-none');
            $('.g-liberaClientes,.g-liberaEmpresa').addClass('d-none');
            $('.fieldPublico').each(function(){
                if($(this).prop('checked')) {
                    var cliente = $(this).val();
                    if (cliente === 'C') {
                        $('.g-liberaClientes').removeClass('d-none');
                    } else if (cliente === 'I') {
                        $('.g-liberaEmpresa').removeClass('d-none');
                    }
                }
            });

            $('.nav-item.grupo-legenda').children('.nav-link').removeClass('active');
            $('.tab-pane.grupo-legenda').removeClass('active');
            $('.tab-pane.grupo-legenda').find('.g-liberaEmpresa').children('textarea').removeAttr('required');
            $('.tab-pane.grupo-legenda').find('.g-liberaClientes').children('textarea').removeAttr('required');

            var firstNavVisible = $(".nav-item.grupo-legenda:not(.d-none)").attr('data-grupo');

            $('.nav-item.grupo-social-' + firstNavVisible).children('.nav-link').addClass('active');
            $('.tab-pane.grupo-social-' + firstNavVisible).addClass('active');
            $('.tab-pane.grupo-legenda:not(.d-none)').find('.g-liberaEmpresa:not(.d-none)').children('textarea').attr('required','required');
            $('.tab-pane.grupo-legenda:not(.d-none)').find('.g-liberaClientes:not(.d-none)').children('textarea').attr('required','required');
        }else{
            $('.tab-pane.grupo-legenda').find('.g-liberaEmpresa').children('textarea').removeAttr('required');
            $('.tab-pane.grupo-legenda').find('.g-liberaClientes').children('textarea').removeAttr('required');
            $('.formLegendas').addClass('d-none');
        }

    }else{
        $('.checkbox-sociais-img').addClass('d-none').children().prop('checked',false).removeAttr('required');
        $('.tab-pane.grupo-legenda').find('.g-liberaEmpresa').children('textarea').removeAttr('required');
        $('.tab-pane.grupo-legenda').find('.g-liberaClientes').children('textarea').removeAttr('required');
        $('.formLegendas').addClass('d-none');
    }
}

function liberaConteudoIdiomas(){
    var categoria = $('[name="categoria_id"]:checked').val();
    var setText = $('[name="set-texto"]:checked').val();
    var vTrad = $('[name="set-traducao"]:checked').val();
    $('.conteudoIdioma').addClass('d-none').find('.idiomaTextField').removeAttr('required');
    if(parseInt(categoria) !== 3 && vTrad === 'I' && setText === 'I'){
        $('.setIdiomas').each(function(){
            var idioma = $(this).val();
            if($(this).prop('checked')){
                $('.conteudoIdioma_'+idioma).removeClass('d-none').find('.idiomaTextField').attr('required','required');
            }
        });
    }
}

function setDireitosAutorais(){
    var isArt = $('[name="set-arte"]:checked').val();
    var isDireitos = $('.isDireitosCheck').length;
    if($('[name="direitos_autorais"]').prop('checked') && (isArt === 'D' || isArt === 'F'  || isDireitos > 0 )){
        $('.groupAutor').removeClass('d-none');
        $('#autor-nome,#autor-email').attr('required','required');
    }else{
        $('.groupAutor').addClass('d-none');
        $('.inputAutor').val('').removeAttr('required');
    }
}

function removeFieldsTraducao(){
    $('.traduzirTexto').addClass('d-none').find('.isRequired').removeAttr('required');
    $('.setIdiomas,[name="set-traducao"]').prop('checked', false);
    $('.trt').addClass('d-none');
    $('.formTraducaoFornecedor').addClass('d-none').find('.isRequired').removeAttr('required');
}

function setTraducao(){
    var vTexto = $('[name="set-texto"]:checked').val();
    var vTrad = $('[name="set-traducao"]:checked').val();
    $('.trt').addClass('d-none').find('.isRequired').removeAttr('required');
    $('.trt-'+vTrad).removeClass('d-none').find('.isRequired').attr('required','required');
    if(vTrad === 'F'){
        $('.formTraducaoFornecedor').removeClass('d-none').find('.isRequired').attr('required','required');
        if(vTexto === 'I'){
            $('.formTradBR').removeClass('d-none').find('.tipoTexto').attr('required','required');            
        }else if(vTexto === 'F'){
            $('.formTradBR').addClass('d-none').find('.tipoTexto').removeAttr('required'); 
        }
    }else{
        $('.formTraducaoFornecedor').addClass('d-none').find('.isRequired').removeAttr('required');
    } 
} 

function setTexto(){ 
    var categoria = $('[name="categoria_id"]:checked').val();
    var vText = $('[name="set-texto"]:checked').val();
    var vTrad = $('[name="set-traducao"]:checked').val();
    var textoImagem = $('#texto-imagem').val();
    $('.txt').addClass('d-none').find('.isRequired').removeAttr('required');
    $('.txt-'+vText).removeClass('d-none').find('.isRequired').attr('required','required');
    $('.detalhesContent').addClass('d-none');
    if(vText === 'N'){
        removeFieldsTraducao();
        $('.detalhesContent').removeClass('d-none');
        $('.formTextoFornecedor').addClass('d-none').find('.isRequired').removeAttr('required');
        $('.formConteudo').addClass('d-none').find('.isRequired').removeAttr('required');

        if(textoImagem !== '' && textoImagem !== undefined && textoImagem !== null){
            $('.revisorContent').removeClass('d-none').find('.isRequired').attr('required','required');
        }
    }else if(vText === 'I'){
        if(vTrad === 'I' || vTrad === 'N'){
            $('.detalhesContent').removeClass('d-none');
            $('.formConteudo').removeClass('d-none').find('.isRequired').attr('required','required');
        }else{
            $('.formConteudo').addClass('d-none').find('.isRequired').removeAttr('required');
        }
    }else{
        $('.formConteudo').addClass('d-none').find('.isRequired').removeAttr('required');
    }
    if(parseInt(categoria) === 3){
        $('.formConteudo').addClass('d-none').find('.isRequired').removeAttr('required');
        $('.setArt_F').removeClass('d-none');
        $('.setArt_N').addClass('d-none').children('input').prop('checked', false);
        removeFieldsTraducao();
    }else{
        $('.setArt_N').removeClass('d-none');
        $('.setArt_F').addClass('d-none').children('input').prop('checked', false);
        $('.traduzirTexto').removeClass('d-none');
        if(vText === 'F'){
            $('.setTrad_I').addClass('d-none').children('input').prop('checked', false); 
        }else{
            $('.setTrad_I').removeClass('d-none');
        }
    }
}

function setArte(){
    var val = $('[name="set-arte"]:checked').val();
    $('.art').addClass('d-none').find('.isRequired').removeAttr('required');
    if($('.contentImgClone').length < 1){
        $('.art-'+val).removeClass('d-none').find('.isRequired').attr('required','required');
    }else{
        $('.art-'+val).removeClass('d-none');
    }

}

function showBtnSave(){
    var categoria = $('[name="categoria_id"]:checked').val();
    var texto = $('[name="set-texto"]:checked').val();
    var traducao = $('[name="set-traducao"]:checked').val();
    var arte = $('[name="set-arte"]:checked').val();
    var acao = $('[name="acao"]').val();
    if(acao === 'solicitacao-editar' || texto === 'F' || arte === 'D' || arte === 'F' || (traducao === 'F' && categoria !== 3) || (texto === 'I' && arte === 'N')){
        $('.buttonSaveContent').removeClass('d-none');
    }else if(texto === 'N' && arte === 'N'){
        $('.buttonSaveContent').addClass('d-none');
    }
}

function showConteudoFields(){
    setTexto();
    atualizaRedesSociais();
    setTraducao();
    liberaConteudoIdiomas();
    setArte();
    setDireitosAutorais();
    showBtnSave();
}
$(document).on('click', '.btn-changeformPass', function (e) {
    var target = $(this).attr('data-target');
    $('.form-signin').addClass('d-none');
    $(target).removeClass('d-none');
})
 
$(document).on('click', '#btnLogin', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        form.ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Autenticando').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if (parseInt(result[1]) === 1) {
                    Swal.fire({
                        title: result[2],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        location.href = result[3];
                    });
                }else if(parseInt(result[1]) === 2){
                    Swal.fire({
                        text: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }else if(parseInt(result[1]) === 3){
                    Swal.fire({
                        html: result[2],
                        icon: 'warning',
                        timer: 5000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        location.href = result[3];
                    });
                }else {
                    $('#user_p4').val(result[2]);
                    $('#pwd_p4').val(result[3]);
                    $('#formValida').submit();
                }
            }
        });
    }
});

$(document).on('click', '#btnRecuperaSenha', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        form.ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Enviando...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                console.log(result);
                if (parseInt(result[1]) === 1) {
                    Swal.fire({
                        html: result[2],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        location.href = result[3];
                    });
                }else{
                    Swal.fire({
                        html: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function (res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '#form-insert-brand .btnSave', function (e) {
    e.preventDefault();
    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Enviando ...').attr('disabled', true);
            },
            success: function (result) {
                result = result.split('|');
                if(parseInt(result[1]) === 1){
                    Swal.fire({
                        title: result[2],
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        location.href = 'home';
                    });
                }else{
                    Swal.fire({
                        text: result[2],
                        icon: 'error',
                        timer: 3000,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    }).then(function(res) {
                        btn.html(btnTextoOriginal).attr('disabled', false);
                    });
                }
            }
        });
    }
});

$(document).on('click', '#btnSalvarPass', function (e) {
    e.preventDefault();

    var btn = $(this);
    var form = btn.closest('form');
    var btnTextoOriginal = btn.html();
    if (form.smkValidate()) {
        if( $.smkEqualPass('#senha', '#confirma_senha') ) {
            //SUBMIT form
            $(form).ajaxSubmit({
                beforeSubmit: function () {
                    btn.html('<span class="spinner-border spinner-border-sm mr-2" role="status"></span> Enviando ...').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) === 1) {
                        Swal.fire({
                            title: result[2],
                            html: result[3],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            location.href = result[4];
                        });
                    } else {
                        Swal.fire({
                            html: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function (res) {
                            btn.html(btnTextoOriginal).attr('disabled', false);
                        });
                    }
                }
            });
        }else{
            Swal.fire({
                text: 'As senhas não conferem!',
                icon: 'error',
                timer: 3000,
                showConfirmButton: false,
                allowOutsideClick: false
            });
        }
    }
});

//FormLogarCom
if($('#FormLogarCom').length){
    $(document).on('click', '#btnSaveLog', function (e) {
        var form = $('#FormLogarCom');
        e.preventDefault();
        if (form.smkValidate()) {
            form.submit();
        }
    })
} 
$(document).on('click', '.btnExcluirMarca', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    var item_id = $(this).attr('data-item');
    var logo = $(this).attr('data-logo');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações e solicitações relacionadas esta marca!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonText: 'Sim, excluir!',
        confirmButtonColor: '#2fb344'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo, item_id: item_id, logo: logo, acao: 'marca-remover'},
                url: "marca-remover",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) === 1) {
                        Swal.fire({
                            title: result[2],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function(res) {
                            location.href = 'marcas/listar';
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 5000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});$(document).on('click', '.btnExcluirServico', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    var item_id = $(this).attr('data-item');
    var logo = $(this).attr('data-logo');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações e solicitações relacionadas este serviço!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonText: 'Sim, excluir!',
        confirmButtonColor: '#2fb344'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo, item_id: item_id, logo: logo, acao: 'servico-remover'},
                url: "servico-remover",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) === 1) {
                        Swal.fire({
                            title: result[2],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        }).then(function(res) {
                            location.href = 'servicos/listar';
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 5000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});

$(document).on('click', '.btnExcluirUsuario', function(e) {
    e.preventDefault();
    var codigo = $(this).attr('data-codigo');
    var item_id = $(this).attr('data-item');
    Swal.fire({
        title: 'Deseja remover realmente?',
        text: "Esta ação irá remover todas as informações relacionadas deste usuário!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d63939',
        confirmButtonText: 'Sim, excluir!',
        confirmButtonColor: '#2fb344'
    }).then((result) => {
        if (result.value) {
            $.ajax({
                type: "POST",
                data: {codigo: codigo, item_id: item_id, acao: 'usuario-remover'},
                url: "usuario-remover",
                success: function (result) {
                    result = result.split('|');
                    if (parseInt(result[1]) === 1) {
                        $('#user' + codigo).remove();
                        Swal.fire({
                            title: result[2],
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    } else {
                        Swal.fire({
                            text: result[2],
                            icon: 'error',
                            timer: 3000,
                            showConfirmButton: false,
                            allowOutsideClick: false
                        });
                    }
                }
            });
        }
    });
});